import "./AboutDepartments.scss";
import React, { useState } from 'react';
import { useNavigate } from "react-router-dom";

import { FiBarChart2, FiInfo, FiAlertCircle   } from 'react-icons/fi';
import { FaSync, FaPlus, FaEdit, FaTrash, FaSave, FaEye, FaSearch, FaDownload, 
    FaUpload, FaCopy, FaPen, FaArrowLeft, FaArrowRight, FaSignInAlt, FaUserPlus, 
    FaBan, FaChevronLeft, FaChevronRight, FaFileAlt, 
    FaChartBar, FaSpinner, FaPaperPlane, FaCheck, FaCheckCircle } from 'react-icons/fa';





const AboutDepartments = () => {

const navigate = useNavigate();
const [openIndex, setOpenIndex] = useState(0);

const toggle = (idx) => {
    setOpenIndex((prev) => (prev === idx ? null : idx));
};

return (
    <section className="aboutSection">
    <div className="container">
        <div className="sectionHead">
        <h2 className="sectionTitle">조직 및 부서 안내</h2>
        <p className="sectionDesc">
            부서를 눌러보면 주요 업무와 역할을 자세히 볼 수 있어요.
        </p>
        </div>

        <div className="accordion">
        <div className={`accItem ${openIndex === 0 ? "open" : ""}`}>
            <button
            type="button"
            className="accHead"
            onClick={() => toggle(0)}
            aria-expanded={openIndex === 0}
            >
            <div className="accLeft">
                <div className="accTitle">인사부</div>
                <div className="accOneLine">신입대사 선발 및 조직 운영 관리</div>
            </div>

            <div className="accRight">
                <div className="accTags">
                <span className="tag">선발</span>
                <span className="tag">운영</span>
                <span className="tag">피드백</span>
                </div>
                <div className="accIcon">{openIndex === 0 ? "−" : "+"}</div>
            </div>
            </button>

            <div className="accBody">
            <div className="accInner">
                <p className="accSummary">신입대사 선발·인수인계부터 대사단 운영 관리, 정기 피드백까지 조직 운영 전반을 담당합니다.</p>

                <div className="accGrid">
                <div className="accBlock">
                <div className="accBlockTitle">주요 업무</div>
                    <ul className="accList">
                        <li>신입대사 선발 및 인수인계</li>
                        <li>대사단 운영 관리</li>
                        <li>정기 피드백 운영</li>
                    </ul>
                </div>

                <div className="accBlock">
                    <div className="accBlockTitle">이런 사람에게 추천</div>
                    <div className="accFit"><FaCheckCircle /> 사람과 조직 운영에 관심 있는 자</div>
                </div>
                </div>
            </div>
            </div>
        </div>

        <div className={`accItem ${openIndex === 1 ? "open" : ""}`}>
            <button
            type="button"
            className="accHead"
            onClick={() => toggle(1)}
            aria-expanded={openIndex === 1}
            >
            <div className="accLeft">
                <div className="accTitle">미디어부</div>
                <div className="accOneLine">지온나래 공식 홍보 콘텐츠 제작</div>
            </div>

            <div className="accRight">
                <div className="accTags">
                <span className="tag">기획</span>
                <span className="tag">콘텐츠</span>
                <span className="tag">디자인</span>
                </div>
                <div className="accIcon">{openIndex === 1 ? "−" : "+"}</div>
            </div>
            </button>

            <div className="accBody">
            <div className="accInner">
                <p className="accSummary">카드뉴스·쇼츠 영상 등 SNS 콘텐츠를 제작하고, 공식 SNS 계정을 운영합니다.</p>

                <div className="accGrid">
                <div className="accBlock">
                    <div className="accBlockTitle">주요 업무</div>
                    <ul className="accList">
                    <li>카드뉴스·쇼츠 등 SNS 콘텐츠 제작</li>
                    <li>공식 SNS 계정 운영</li>
                    </ul>
                </div>

                <div className="accBlock">
                    <div className="accBlockTitle">이런 사람에게 추천</div>
                    <div className="accFit"><FaCheckCircle /> 콘텐츠 제작·디자인·영상 편집에 관심 있는 자</div>
                </div>
                </div>
            </div>
            </div>
        </div>

        <div className={`accItem ${openIndex === 2 ? "open" : ""}`}>
            <button
            type="button"
            className="accHead"
            onClick={() => toggle(2)}
            aria-expanded={openIndex === 2}
            >
            <div className="accLeft">
                <div className="accTitle">대내부</div>
                <div className="accOneLine">기념품 제작 및 오프라인 이벤트 기획</div>
            </div>

            <div className="accRight">
                <div className="accTags">
                <span className="tag">기획</span>
                <span className="tag">운영</span>
                <span className="tag">이벤트</span>
                </div>
                <div className="accIcon">{openIndex === 2 ? "−" : "+"}</div>
            </div>
            </button>

            <div className="accBody">
            <div className="accInner">
                <p className="accSummary">단복·명함 등 기념품 제작과 교내 오프라인 이벤트 기획·운영을 담당합니다.</p>

                <div className="accGrid">
                <div className="accBlock">
                    <div className="accBlockTitle">주요 업무</div>
                    <ul className="accList">
                    <li>단복·명함 등 기념품 제작</li>
                    <li>교내 오프라인 이벤트 기획 및 운영</li>
                    </ul>
                </div>

                <div className="accBlock">
                    <div className="accBlockTitle">이런 사람에게 추천</div>
                    <div className="accFit"><FaCheckCircle /> 기획·운영·현장 활동에 관심 있는 자</div>
                </div>
                </div>
            </div>
            </div>
        </div>

        <div className={`accItem ${openIndex === 3 ? "open" : ""}`}>
            <button
            type="button"
            className="accHead"
            onClick={() => toggle(3)}
            aria-expanded={openIndex === 3}
            >
            <div className="accLeft">
                <div className="accTitle">대외부</div>
                <div className="accOneLine">캠퍼스 투어 및 대외 프로그램 운영</div>
            </div>

            <div className="accRight">
                <div className="accTags">
                <span className="tag">투어</span>
                <span className="tag">대외</span>
                <span className="tag">소통</span>
                </div>
                <div className="accIcon">{openIndex === 3 ? "−" : "+"}</div>
            </div>
            </button>

            <div className="accBody">
            <div className="accInner">
                <p className="accSummary">캠퍼스 투어 운영과 정기 소식지 제작, 캠프 운영 및 각종 공식 행사 지원을 담당합니다.</p>

                <div className="accGrid">
                <div className="accBlock">
                    <div className="accBlockTitle">주요 업무</div>
                    <ul className="accList">
                    <li>캠퍼스 투어 운영</li>
                    <li>정기 소식지 제작 및 캠프 운영</li>
                    <li>각종 공식 행사 지원</li>
                    </ul>
                </div>

                <div className="accBlock">
                    <div className="accBlockTitle">이런 사람에게 추천</div>
                    <div className="accFit"><FaCheckCircle /> 대외 활동·안내·소통 역할에 관심 있는 자</div>
                </div>
                </div>
            </div>
            </div>
        </div>
        </div>

        <div className="ctaBox">
        <div className="ctaText">
            <div className="ctaTitle">지온나래 활동이 궁금해요</div>
            <div className="ctaDesc">
            활동 사진과 실제 운영 이야기는 '지온나래 활동' 페이지에서 더 자세히 볼 수 있어요.
            </div>
        </div>

        <div className="ctaActions">
            <a className="btn primary" onClick={() => navigate('/about/activities')}>
            활동 보러가기 <FaArrowRight />
            </a>
            <a className="btn primary" onClick={() => navigate('/tour')}>
            캠퍼스 투어 보기 <FaArrowRight />
            </a>
        </div>
        </div>
    </div>
    </section>
);
};

export default AboutDepartments;